// src/seo/StructuredData.jsx
const SITE_URL = "https://www.estateghar.com"; // ⚠️ change to your real domain
const SITE_NAME = "EstateGhar";

export const buildItemListLd = ({ listingType, cityName, properties }) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: cityName
    ? `Properties for ${listingType} in ${cityName}`
    : `Properties for ${listingType} in Pakistan`,
  numberOfItems: properties.length,
  itemListElement: properties.slice(0, 25).map((p, i) => ({
    "@type": "ListItem",
    position: i + 1,
    url: `${SITE_URL}/property/${p.id}`,
    name:
      p.data?.title ||
      `${p.data?.propertyType || "Property"} for ${listingType} in ${
        p.data?.city || "Pakistan"
      }`,
  })),
});

export const buildBreadcrumbLd = ({ listingType, cityName, citySlug }) => {
  const items = [
    { name: "Home", item: SITE_URL },
    {
      name:
        listingType === "rent" ? "Properties for Rent" : "Properties for Sale",
      item: `${SITE_URL}/properties-for-${listingType}`,
    },
  ];

  if (cityName && citySlug) {
    items.push({
      name: cityName,
      item: `${SITE_URL}/properties-for-${listingType}-in-${citySlug}`,
    });
  }

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.item,
    })),
  };
};

export const buildFaqLd = ({ listingType, cityName, count }) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: `How many properties are available for ${listingType} in ${
        cityName || "Pakistan"
      }?`,
      acceptedAnswer: {
        "@type": "Answer",
        text: `There are currently ${count} properties listed for ${listingType} in ${
          cityName || "Pakistan"
        } on ${SITE_NAME}.`,
      },
    },
    {
      "@type": "Question",
      name: `How do I find the best property for ${listingType} in ${
        cityName || "Pakistan"
      }?`,
      acceptedAnswer: {
        "@type": "Answer",
        text: `Use our filters to narrow down by property type, area, and price range. You can also contact the listing agent directly via WhatsApp for quick response.`,
      },
    },
    {
      "@type": "Question",
      name: `Are these ${listingType} listings verified?`,
      acceptedAnswer: {
        "@type": "Answer",
        text: `Yes, all listings on ${SITE_NAME} are posted by verified agents and property owners. Always visit the property in person before finalizing any deal.`,
      },
    },
  ],
});

export const buildOrganizationLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  sameAs: [],
});